// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"43eecd1d","488":"e9783004","605":"b0fdec20","943":"e2f4764d"}[chunkId] + ".chunk.js";
};